import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const CaffeinateCampaignSubscriptionSchema = withDefaults({
  type: 'caffeinate-campaign-subscription',
  fields: [
    {
      kind: 'attribute',
      name: 'token',
    },
    {
      kind: 'attribute',
      name: 'endedAt',
    },
    {
      kind: 'attribute',
      name: 'endedReason',
    },
    {
      kind: 'attribute',
      name: 'resubscribedAt',
    },
    {
      kind: 'attribute',
      name: 'unsubscribedAt',
    },
    {
      kind: 'attribute',
      name: 'unsubscribeReason',
    },
    {
      kind: 'attribute',
      name: 'subscriberType',
    },
    {
      kind: 'attribute',
      name: 'subscriberId',
    },
    {
      kind: 'attribute',
      name: 'userType',
    },
    {
      kind: 'attribute',
      name: 'userId',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'caffeinateCampaign',
      type: 'caffeinate-campaign',
      options: {
        async: false,
        inverse: 'caffeinateCampaignSubscriptions',
      },
    },
    {
      kind: 'hasMany',
      name: 'caffeinateMailings',
      type: 'caffeinate-mailing',
      options: {
        async: false,
        inverse: 'caffeinateCampaignSubscription',
      },
    },
  ],
});

export default CaffeinateCampaignSubscriptionSchema;
